import { memo } from 'react';
import {
  PhoneNumberInput,
  type PhoneNumberInputProps,
} from '@adc/parallax-component-library';

type PhoneInputProps = PhoneNumberInputProps & {
  isInvalid?: boolean;
  errorMessage?: string;
};

export const PhoneInput = memo(
  ({
    isInvalid = false,
    label,
    errorMessage,
    placeholder = '',
    value,
    onBlur,
    onChangeText,
    disabled,
    testID,
    onFocus,
    ...props
  }: PhoneInputProps) => {
    const showsErrorMessage = isInvalid && errorMessage;

    return (
      <PhoneNumberInput
        inputMode="tel"
        aria-label={label}
        label={label}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        error={isInvalid}
        supportingText={showsErrorMessage ? errorMessage : undefined}
        onChangeText={onChangeText}
        value={value}
        testID={testID}
        disabled={disabled}
        {...props}
      />
    );
  },
);

PhoneInput.displayName = 'PhoneInput';
